import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="row justify-content-end">
      <div
        className="col-lg-3 col-md-12 footer-about-widget"
        data-aos="fade-up"
        data-aos-duration="1200"
      >
        <a href="index.html" className="logo">
          <img src="images/logo/deski_02.svg" alt="" />
        </a>
      </div>
      
      <div
        className="col-lg-3 col-md-4 footer-list"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="50"
      >
        <h3 className="footer-title">Services</h3>
        <ul>
          <li>
            <Link to="/unreal-engine-game-development">   Unreal Game Development</Link>
          </li>
          <li>
            <Link to="/unity-game-development">Unity Game Development</Link>
          </li>
           <li>
            <Link to="/ar-vr-development">AR/VR Development</Link>
          </li>
          <li>
            <Link to="/ai-development-company">AI Development</Link>
          </li>
          <li>
            <Link to="/blockchain-app">Blockchain </Link>
          </li>
          
          
          
         
        </ul>
      </div>
      {/* /.footer-list */}
      <div
        className="col-lg-3 col-md-4 footer-list"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="100"
      >
        <h3 className="footer-title">Company</h3>
        <ul>
          <li>
            <Link to="/about-us">About us</Link>
          </li>
          <li>
            <Link to="/faq-details">Career</Link>
          </li>
          <li>
            <Link to="/blog">Blog</Link>
          </li>
          
        </ul>
      </div>
      {/* /.footer-list */}
      {/* <div
        className="col-lg-3 col-md-4 address-list"
        data-aos="fade-up"
        data-aos-duration="1200"
        data-aos-delay="150"
      >
        <h5 className="footer-title">Address</h5>
        <ul>
          <li>
            <a href="#">companyinfo@mail.com</a>
          </li>
          <li>
            <a href="#" className="mobile-num">
              +761 412 3224
            </a>
          </li>
        </ul>
      </div> */}
      {/* /.footer-list */}
    </div>
    
  );
};

export default Footer;
